import styles from './WhatsappChallanNewFlow.module.scss'

const ChallanListItem = ({ challan }) => (
  <>
    <div className={styles.challan}>
      <div className={styles.challanInfo}>
        <div className={styles.challanViolationName}>{challan?.violationName}</div>
        <div className={styles.challanTime}>{challan?.date}</div>
      </div>
      <div className={styles.challanAmount}>₹{challan?.totalAmount}</div>
    </div>
    <div className={styles.lineStyles} />
  </>
)

export default ChallanListItem
